import { Injectable } from '@angular/core';
import { DestinationCenter } from '@app/models/destination-center';
import { DestinationCenterService } from '@app/services/api/destination-center.service';

import {
  Load,
  LoadAll,
  LoadSuccess,
  LoadFail,
  // GetAll,
  // GetAllSuccess,
  // GetAllFail,
  Update,
  UpdateSuccess,
  UpdateFail,
  Create,
  CreateSuccess,
  CreateFail,
  Delete,
  DeleteSuccess,
  DeleteFail,
  DestinationCenterActionTypes
} from '@core/actions/destination-center.actions';
import * as fromDestination from '@core/actions/destination.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, concatMap, tap } from 'rxjs/operators';
import { FlashService } from '@app/services/flash.service';

@Injectable()
export class DestinationCenterEffects {
  @Effect()
  load$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<Load>(DestinationCenterActionTypes.Load),
    switchMap(action => {
      return this.destinationCenterApi.get(action.FollowId).pipe(
        map((destinationCenters: any[]) => new LoadSuccess(destinationCenters)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  LoadAll$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<LoadAll>(DestinationCenterActionTypes.LoadAll),
    switchMap(()=>{
      return this.destinationCenterApi.getAll().pipe(
        map((destinationCenters: any[]) => new LoadSuccess(destinationCenters)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  update$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<Update>(DestinationCenterActionTypes.Update),
    map(action => [action.id, action.destination]),
    concatMap(([id, destination]) =>
      this.destinationCenterApi.update(id, destination).pipe(
        map(product => { return new UpdateSuccess(product)}),
        catchError(error => of(new UpdateFail(error)))
      )
    )
  );

  // @Effect()
  // GetAll$: Observable<Action> = this.destinationCenter$.pipe(
  //   ofType<GetAll>(DestinationCenterActionTypes.GetAll),
  //   switchMap(()=>{
  //     return this.destinationCenterApi.getAllDestination().pipe(
  //       map((destinationCenters: any[]) => new GetAllSuccess(destinationCenters)),
  //       catchError(error => of(new GetAllFail(error)))
  //     );
  //   })
  // );

  @Effect()
  UpdateSuccess$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<UpdateSuccess>(DestinationCenterActionTypes.UpdateSuccess),
    concatMap(action => {
      this.fs.emit({ type: 'success', message: 'Destino editado' });
      return [new LoadAll(), new fromDestination.Load()]
    })
  );

  @Effect()
  Create$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<Create>(DestinationCenterActionTypes.Create),
    map(action => [action.data]),
    concatMap(([data]) =>
      this.destinationCenterApi.create(data).pipe(
        map(product => { return new CreateSuccess(product)}),
        catchError(error => of(new CreateFail(error)))
      )
    )
  );

  @Effect({ dispatch: false })
  CreateFail$ = this.destinationCenter$.pipe(
   ofType<CreateFail>(DestinationCenterActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        type: 'danger',
        message: res.error.error.message
      })
    )
  );

  @Effect()
  CreateSuccess$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<CreateSuccess>(DestinationCenterActionTypes.CreateSuccess),
    concatMap(action => {
      this.fs.emit({ type: 'success', message: 'Destino creado' });
      return [new LoadAll(), new fromDestination.Load()]
    })
  );

  @Effect()
  Delete$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<Delete>(DestinationCenterActionTypes.Delete),
    map(action => [action.data]),
    concatMap(([data]) =>
      this.destinationCenterApi.delete(data).pipe(
        map(product => { return new DeleteSuccess(product)}),
        catchError(error => of(new DeleteFail(error)))
      )
    )
  );

  @Effect()
  DeleteSuccess$: Observable<Action> = this.destinationCenter$.pipe(
    ofType<DeleteSuccess>(DestinationCenterActionTypes.DeleteSuccess),
    concatMap(action => {
      this.fs.emit({ type: 'success', message: 'Destino Eliminado' });
      return [new LoadAll(), new fromDestination.Load()]
    })
  );

  @Effect({ dispatch: false })
  DeleteFail$ = this.destinationCenter$.pipe(
   ofType<DeleteFail>(DestinationCenterActionTypes.DeleteFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        type: 'danger',
        message: res.error.error.message
      })
    )
  );

  constructor(
    private destinationCenter$: Actions,
    private destinationCenterApi: DestinationCenterService,
    private fs: FlashService
  ) {}
}
